import { render, staticRenderFns } from "./UserImageOnly.vue?vue&type=template&id=0bd12d52&scoped=true&"
import script from "./UserImageOnly.vue?vue&type=script&lang=js&"
export * from "./UserImageOnly.vue?vue&type=script&lang=js&"
import style0 from "./UserImageOnly.vue?vue&type=style&index=0&id=0bd12d52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd12d52",
  null
  
)

export default component.exports